import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './BoxShell.scss'
import { SlideIn } from '../Transitions'

const BoxShell = ({ height, dark, children }) => {
	return (
		<SlideIn from="left">
			<div styleName={dark ? 'box-dark' : 'box'} style={{ height }}>
				{children}
			</div>
		</SlideIn>
	)
}

export default CSSModules(BoxShell, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Shells/BoxShell.js